import Vue from 'vue'

function setupWebViewJavascriptBridge(callback) {
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
  if (isAndroid) {
    if (window.WebViewJavascriptBridge) {
      callback(window.WebViewJavascriptBridge)
    } else {
      document.addEventListener('WebViewJavascriptBridgeReady', () => {
        callback(window.WebViewJavascriptBridge)
      }, false)
    }
  } else {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge)
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback)
    }
    window.WVJBCallbacks = [callback]
    const WVJBIframe = document.createElement('iframe')
    WVJBIframe.style.display = 'none'
    WVJBIframe.src = 'https://__bridge_loaded__'
    document.documentElement.appendChild(WVJBIframe)
    setTimeout(() => {
      document.documentElement.removeChild(WVJBIframe)
    }, 0)
  }
}

/**
 * @func 调用原生的方法
 * @param {String} fun 桥接名
 * @param {Object} params 参数
 * @param {Bollean} hasCallback 原生是否执行我们的回调函数
 * @author yyc
 */
function invoke(fun, params = '', hasCallback = false) {
  console.log('invoke', fun, params, hasCallback)
  return new Promise((resolve, reject) => {
    try {
      setupWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler(fun, params, function (res) {
          // 如果有回调就从回调中resolve
          console.log('*******', res)
          if (typeof res === 'string' && /^\{.+\}$/.test(res)) {
            res = JSON.parse(res)
          }
          hasCallback && resolve(res)
        })
      })
      // 如果没有回调就直接resolve
      !hasCallback && resolve()
    } catch (err) {
      reject(err)
    }
  })
}

/**
 * @func 原生调用我们的方法
 * @param {String} name 桥接名
 * @author yyc
 */
function register(name) {
  return new Promise((resolve, reject) => {
    try {
      setupWebViewJavascriptBridge((bridge) => {
        bridge.registerHandler(name, (res) => {
          // resolve(typeof res === 'string' ? JSON.parse(res) : res)
          if (typeof res === 'string' && /^\{.+\}$/.test(res)) {
            res = JSON.parse(res)
          }
          resolve(res)
        })
      })
    } catch (err) {
      reject(err)
    }
  })
}

const ua = navigator.userAgent.toLowerCase()
const isAndroid = ua.indexOf('android') >= 0
const isIOS = ua.indexOf('iphone') >= 0 || ua.indexOf('ipad') >= 0

const apiList = {
  isAndroid,
  isIOS,
  /**
  * @func 调用原生相机
  * @param  {Object} type 0-相机拍摄 1-从相册上传 2-OCR相机
  * @param  {OBject} identityType 0-身份证正面 1-身份证反面
  * @param  {Object} width 默认0
  * @param  {Object} height 默认0
  * @param  {Object} cutting  cutting代表是否裁剪
  */
  async imageSelectFunc (params) {
    await invoke('imageSelectFunc', params)
    return register('returnImagesForJs')
  },

  /**
   * @func 图片预览
   */
  async jumpToPreviewImages (params) {
    await invoke('jumpToPreviewImages', params)
    return register('returnImagesForJs')
  },

  /**
   * @func Bi统计数据埋点上报
   */
  reportBiStatisticsFunc: (params) => invoke('reportBiStatisticsFunc', params),

  /**
   * @func 获取app通用信息版本号
   */
  getAppInfoFunc: (params) => invoke('getAppInfoFunc', params, true),

  /**
   * @func 跳转外链给到原生桥接
   */
  jumpOutUrl: (params) => invoke('jumpUrl', params),

  /**
   * @func 跳转到原生地图导航
   */
  jumpMapNavigation: (params) => invoke('jumpMapNavigation', params),

  /**
   * @func 跳转到七鱼客服
   */
  getQYServer: () => invoke('getQYServer'),
  /**
   * @func 跳转到七鱼客服（ios 4.0以上版本支持 新桥接）
   */
  pushQYServer: () => invoke('pushQYServer'),

  /**
   * @func 修改电池栏颜色
   */
  modifyStatusBarFunc: (params) => invoke('modifyStatusBarFunc', params),

  /**
   * @func 返回到原生页面
   */
  backNativeApp: (params) => invoke('toReturnApp', params),

  /**
   * @func 获取门店信息
   */
  getCurrentStoreInfo: () => invoke('getCurrentStoreInfo', '', true),

  /**
   * @func 分享微信/支付宝
   */
  onAppShare: (params) => invoke('shareFunc', params),

  /**
   * @func 保存图片
   */
  downloadImage: (params) => invoke('downloadImagesFunc', params),

  /**
   * @func 跳转到具体的账单详情
   */
  jumpToBillDetail: (params) => invoke('jumpBillDetail', params),

  /**
   * @func 导出url, 参数copyUrl：'' 具体的url
   */
  copyExportUrl: (params) => invoke('copyExportUrl', params),
  /**
   * @func 跳转到绑定银行卡
   */
  jumpToBindCard: () => invoke('MyCardPage'),

  /**
   * @func 跳转到扫码点单
   */
  jumpToScanOrder: (params) => invoke('jumpToScanOrder', params),

  /**
   * @func 升级app
   */
  appUpdate: () => invoke('exeUpgrade'),

  /**
   * @func 获取用户信息
   */
  getUserInfo: (params) => invoke('getInfo', params, true),

  /**
   * @func 跳转到angular页面
   */
  jumpToAngularPage: (params) => invoke('jumpToAngularPage', params),

  /**
   * @func 跳转到新版angular页面
   */
  jumpToNewAngularPage: (params) => invoke('jumpToNewAngularPage', params),

  /**
   * @func 选择时间
   */
  async openTimePicker(params) {
    await invoke('openTimePicker', params)
    return register('pushCheckedTime')
  },

  /**
   * @func 选择日期
   */
  async openDatePicker(params) {
    await invoke('openDatePicker', params)
    return register('pushCheckedDate')
  },

  /**
   * @func 跳转到第三方浏览器
   */
  jumpToBrowser: (params) => invoke('jumpToBrowser', params),

  /**
   * @func 跳转到360贷款
   */
  jumpTo360Loan: () => invoke('jumpTo360Loan'),

  /**
   * @func 设置导航栏右边文字
   */
  setNavigationBarRightDo: (params) => invoke('setNavigationBarRightDo', params),

  /**
   * @func 设置导航栏title
   */
  setNavigationBarTitle: (params) => invoke('setNavigationBarTitle', params),

  /**
   * @func 友盟埋点
   */
  reportUmengEvent: (params) => invoke('reportUmengEvent', params),

  /**
   * @func 选择日期桥接
   */
  async selectCalendar (params) {
    await invoke('jumpToCalendar', params)
    return register('putCalendarRange')
  },

  /**
   * @func 选择的门店列表
   */
  selectStoreInfo: (params) => invoke('selectStoreInfo', params),

  /**
   * @func 选择门店后原生跳转到h5的数据回显
   */
  selectStoreInfoBack: () => invoke('selectStoreInfoBack', '', true),

  /**
   * @func 重新登录
   */
  toReStartLogin: (params) => invoke('toReStartLogin', params),

  /**
   * @func 上报页面统计
   */
  reportPageStatistics: (params) => invoke('reportPageStatisticsFunc', params),

  /**
   * @func 跳转到账单详情
   */
  jumpToStatisticsDetail: (params) => invoke('jumpToStatisticsDetail', params),

  /**
   * @func 自定义tab点击
   */
  customTabClick: (params) => invoke('customTabClick', params),

  /**
   * @func 判断当前桥是否可用
   */
  canIUse: (params) => invoke('canIUse', params, true),

  /**
   * @func 是否可以返回
   */
  canGoBack: () => invoke('canGoBack', '', true),

  /**
   * @func 酒店预授权打印
   */
  printCashBill: (params) => invoke('printCashBill', params),

  /**
   * @func 打开微信小程序
   */
  openMiniProgram: (params) => invoke('openMiniProgram', params),

  /**
   * @func 扫码二维码
   */
  async scanQRCode (params) {
    await invoke('scanQRCode', params)
    return register('getCodeContent')
  },

  /**
   * @func 调用浏览器的返回事件，理解成就是模拟点击了物理返回键
   */
  appWebviewBack: (params) => invoke('appWebviewBack', params),

  /**
   * @func h5通知原生新的url，参数有url， type-1表示商户贷页面，2跳转到活动详情，3跳转到消息详情；fromSource: 1-商户贷，2-个人贷
   */
  originalOpenUrl: (params) => invoke('originalOpenUrl', params),
  /**
   * @function 打开原生url，参数有url,
   * @param { Object } params type: 1 默认 2 提现银行卡  3.门店管理 4.协议；isHiddenNav：是否隐藏导航栏；navTitle：导航栏标题；url: 跳转链接
   * @returns
   */
  openUrlFromH5: (params) => invoke('openUrlFromH5', params),
  /**
   * @func h5埋点通知原生，type为1，表示是活动报名，itemId: 列表id（比如活动列表id）,pagetype,1表示从活动列表，2表示从消息详情，为了配合type等于1的去情况
   */
  statisticPoint: (params) => invoke('statisticPoint', params),
  /**
   * @func 使用系统导航
   */
  useSystemNavagation: (params) => invoke('useSystemNavagation', params),
  selectBranchLocation: function (params, callBack) {
    invoke('selectBranchLocation', params, function (res) {
      console.log('********selectBranchLocation************', res)
      callBack(JSON.parse(res))
    })
    register('getBranchLocation', function (res) {
      console.log('******** getBranchLocation************', res)
      callBack(JSON.parse(res))
    })
  },
  /**
   * @func 跳转到退款页面
   */
  // toRefundPage: (params) => invoke('toRefundPage', params),
  async toRefundPage(params) {
    await invoke('toRefundPage', params)
    return register('refundCallback')
  },
  /**
   * @func 选择省市区
   */
  async selectLocation(params) {
    await invoke('selectLocation', params)
    return register('getLocation')
  },
  uploadImage: function (params, callBack) {
    // params:
    //    {previewImageUrl operateAbleFlag isTailoring}  预览模式 是否可以删除 是否可以裁剪成正方形
    //    {'', false}  选择图片模式
    invoke('uploadImage', params, function (res) {
      console.log('********uploadImage************', res)
      callBack(JSON.parse(res))
    })
    register('putUploadedImage', function (res) {
      console.log('********putUploadedImage************', res)
      callBack(JSON.parse(res))
    })
  },
  // 上传视频
  async getVideoInfo (params) {
    console.log('********getVideoInfo************', params)
    await invoke('getVideoInfo', params)
    return register('putVideoInfo')
  },
  browsePic: function (params, callBack) {
    // params: {images: [图片列表]}
    console.log('多图预览桥接调用开始', params)
    invoke('browsePic', params, function (res) {
      console.log('********browsePic************', res)
      callBack(JSON.parse(res))
    })
    register('browsePicCb', function (res) {
      console.log('********browsePicCb************', res)
      callBack(JSON.parse(res))
    })
  },
  /**
 * 日期选择
 * @param {boolean} (isShow)
 */
  async getDateSelect(params, callback) {
    const result = await invoke('getDateSelect', params, callback)
    callback(result)
  },
  /**
   * 语音转文字
   */
  async getSpeechToText (params) {
    await invoke('getSpeechToText', params)
    return register('getTextBySpeech')
  },
  /**
   * 安卓语音转文字
   */
  getSpeechToAndroidText: (params) => invoke('getSpeechToText', params, true),

  /**
   * @func 是否是AI收款单助手
   */
  showAIHelper: (params) => invoke('showAIHelper', params),
  /**
   * 原生日期选择-到秒
   * @param {boolean}
   */
  getDateSelectAll: function (params, callBack) {
    invoke('getDateSelectAll', params, function (res) {
      console.log('********getDateSelectAll************', res)
      callBack(res)
    })
    register('getDateSelectAllCb', function (res) {
      console.log('********getDateSelectAllCb************', res)
      callBack(res)
    })
  },
  /**
     * 调用Ocr相机
     */
  async uploadIdCard(params, callBack) {
    await invoke('toShowUploadIdCard', params)
    const registerData = await register('cbIdCardInfo')
    callBack(registerData)
  },
  /**
   * 调用Ocr相机
   */
  uploadLicenseInfo: function (params, callBack) {
    invoke('toShowUploadIdCard', params, function (res) {
      console.log('********toShowUploadIdCard************', res)
      callBack(JSON.parse(res))
    })
    register('cbLicenseInfo', function (res) {
      console.log('******** cbLicenseInfo************', res)
      callBack(JSON.parse(res))
    })
  }
}

window.setupWebViewJavascriptBridge = setupWebViewJavascriptBridge
window.$jfs = apiList
Vue.prototype.$jfs = apiList

export default setupWebViewJavascriptBridge
